import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { EspecialidadeFilial } from '../../especialidade/especialidade-filial';
import { EspecialidadeService } from '../../especialidade/especialidade.service';
import { EspecialidadeFilialPk } from '../../especialidade/pks/especialidade-filial-pk';
import { Filial } from '../../filial/filial';
import { FilialService } from '../../filial/filial.service';
import { AbastractAssociacao } from '../abstract.associacao';

@Component({
  selector: 'app-associacao-filial-especialidade',
  templateUrl: '../associacao.component.html',
  styleUrls: ['../associacao.component.css']
})
export class AssociacaoFilialEspecialidadeComponent extends AbastractAssociacao {

  constructor(private filialService: FilialService,
    private especialidadeService: EspecialidadeService,
    formBuilder: FormBuilder,
    dialog: MatDialog) {

    super(formBuilder, dialog);

  }

  ngOnInit() {

    super.ngOnInit();

    this.tituloAssociacao = 'Associação Filial x Especialidade';
    this.nomeCampoAssociacaoPai = 'Filial';
    this.nomeCampoAssociacaoFilho = 'Especialidade';

    this.configurarForm();
  }

  getListaDePais(): Observable<any> {

    return this.filialService.listarFiliaisComRelacaoMinimaDeEspecialidade();

  }

  getListaDeFilhos(): Observable<any> {

    return this.especialidadeService.listar();

  }

  getListaDeFilhosSelecionados(): any {

    return (this.associacaoPai as Filial).especialidadeFilial;

  }

  getIdFilhoFromAssociacaoComPai(currentAssociacao: any): any {

    return currentAssociacao.pk.idEspecialidade;
  }

  configurarAssociacoesFilhas(associacoesFilhas: any): void {

    let pai: Filial = this.associacaoPai as Filial;

    pai.especialidadeFilial = [];

    if (associacoesFilhas) {

      associacoesFilhas.forEach((currentFilho: any) => {
        pai.especialidadeFilial.push(this.getAssociacaoPaiFilho(currentFilho));
      });

    }
  }

  getAssociacaoPaiFilho(currentFilho: any): any {

    const associacao: EspecialidadeFilial = new EspecialidadeFilial();
    associacao.pk = new EspecialidadeFilialPk();
    associacao.pk.idFilial = this.associacaoPai.id;
    associacao.pk.idEspecialidade = currentFilho.id;

    return associacao;

  }

  salvarAssociacao(value: any): Observable<Object> {

    return this.filialService.atualizaRelacaoFilialEspecialidade(value);
  }

}
